export const VALIDATION = {
  required: { value: true, message: 'A quote PDF is required.' },
};

export const AI_DOC_MODAL_ID = 'ai-doc';
